import { Injectable } from '@angular/core';
import {AppConfig} from '../app/app.config';
import {CommonService} from '../service/common.service';
declare var signalR;
declare var app;
@Injectable({
  providedIn: 'root'
})
export class SignalrclientService {

  constructor(private appConfig:AppConfig,private com:CommonService) { }
  /**
   * 调用signalR消息提醒
   */
  SignalRConnection():Promise<any>{
    const that = this;
    return new Promise<any>((resolve,reject)=>{
      that.appConfig.hubConnection =  new signalR.HubConnectionBuilder()
      .withUrl(app.SIGNALRURL+that.com.GetAccount.Id)//, { transport: signalR.HttpTransportType.WebSockets }) //不设置链接类型，让系统自动选择
      .configureLogging(signalR.LogLevel.Information)
      .build();
      that.appConfig.hubConnection.start().then(function(tools){
          that.appConfig.hubConnection.stream("SysHubNoticeStartStreaming").subscribe({
            next: function (resp) {
            //这里写正常接收到数据之后的业务逻辑
            console.log("这里写正常接收到数据之后的业务逻辑");
            resolve(resp);
            },
            err: function (err) {
                console.log(err);
                reject(err);
            },
            complete: function () {
                console.log("完成流传输");
            }
        });
      }).catch(error=>{
        console.error(error);
        reject(error);
      });
    });
  }
  /**
   * 消息提醒
   * @param arrayConfig ILocalNotification类型消息参数
   */
  NotificationMessage(arrayConfig:any){
  const that = this;
  //  that.localNotification.schedule(arrayConfig);
  }
  /**
   * 消息点击返回事件
   */
  NotificationClickEvent():Promise<any>{
    const that = this;
    return new Promise<any>((resolve,reject)=>{
    // that.localNotification.on('click').subscribe(obser=>{
    // resolve(obser);
    // },error=>{
    // reject(error);
    // });
    })
  }
}
